export const RoutePath = {
	// ログイン
	LOGIN: '/login',
	// 共通ログイン
	COMMON_LOGIN: '/common-login',
	// リダイレクトログイン
	REDIRECT_LOGIN: '/redirect-login',
	// 新規会員登録1(メール送信画面)
	USER_REGISTER_1: '/user-register-1',
	// 新規会員登録2(ワンタイムパスワードチェック画面)
	USER_REGISTER_2: '/user-register-2',
	// 新規会員登録3-1(ユーザ情報入力画面)
	USER_REGISTER_3_1: '/user-register-3-1',
	// 新規会員登録3-2(ユーザ情報入力続き画面)
	USER_REGISTER_3_2: '/user-register-3-2',
	// 新規会員登録4(ユーザ情報入力確認画面)
	USER_REGISTER_4: '/user-register-4',
	// 新規会員登録5(登録後画面)
	USER_REGISTER_5: '/user-register-5',
	// 規約同意
	TERMS: '/terms',
	// 規約同意完了
	TERMS_COMPLETE: '/terms-complete',
	// マイページトップ
	MY_PAGE: '/my-page',
	// プロフィール編集
	PROFILE_EDIT: '/profile-edit',
	// プロフィール編集（メールアドレス変更確認）
	PROFILE_EDIT_MAILADDRESS: '/profile-edit-mailaddress',
	// プロフィール編集（メールアドレス確認ワンタイムパスワードチェック）
	PROFILE_EDIT_MAILADDRESS_CONFIRM: '/profile-edit-mailaddress-confirm',
	// パスワード変更
	PASSWORD_EDIT: '/password-edit',
	// パスワード忘れ
	FORGOT_PASSWORD: '/forgot-password',
	// パスワード忘れ（メールアドレス確認ワンタイムパスワードチェック）
	FORGOT_PASSWORD_CONFIRM: '/forgot-password-confirm',
	// パスワード忘れ（パスワード更新）
	FORGOT_PASSWORD_UPDATE: '/forgot-password-update',
	// エラー
	ERROR: '/error',
	// 規約
	AGREEMENT: '/agreement',
	// 規約（英語）
	AGREEMENT_EN: '/agreement-en',
	// not found
	NOT_FOUND: '/notfound',
	// ユーザー情報
	MEMBER_INFO: '/member-info',
	// メンバーの削除
	MEMBER_REMOVE: '/member-remove',
	// メンバーの削除(お問い合わせフォーム)
	MEMBER_REMOVE_CONTACT_FORM: '/member-remove-contact-form',
	// メンバー情報の変更
	MEMBER_UPDATE: '/member-update',
	// メンバー情報の入力
	MEMBER_INPUT: '/member-input',
	// メンバー情報の追加
	MEMBER_ADD: '/member-add',
	// メンバー情報の入力
	MEMBER_INPUT_WITH_USER_REGISTER: '/member-input-with-user-register',
	// ユーザーの追加
	USER_ADD: '/user-add',
	// 代表者を変更する
	CHANGE_REPRESENTATIVE: '/change-representative',
	// 家族からはずす
	GET_OUT_FAMILY: '/get-out-family',
	// 招待への同意
	INVITATION_AGREE: '/invitation-agree',
	// 家族から抜ける
	LEAVE_FAMILY: '/leave-family',
	// 家族から抜ける（自分だけ抜ける）
	LEAVE_FAMILY_ONLY: '/leave-family-only',
	// 家族から抜ける（⼀緒に抜けるメンバーを選択）
	LEAVE_FAMILY_TOGETHER: '/leave-family-together',
	// 決済
	PAYMENT: '/payment',
	// 決済(定期購読)
	PERIODIC_PAYMENT: '/periodic-payment',
	// 一括決済
	BULK_PAYMENT: '/bulk-payment',
	// 一括決済(定期購読)
	BULK_PERIODIC_PAYMENT: '/bulk-periodic-payment',
	// 一括決済完了画面
	BULK_PAYMENT_COMPLETE: '/bulk-payment-complete',
	// 一括決済(定期購読)完了画面
	BULK_PERIODIC_PAYMENT_COMPLETE: '/bulk-periodic-payment-complete',
	// ID忘れ
	FORGOT_ID: '/forgot-id',
	// ID忘れ（メールアドレス確認ワンタイムパスワードチェック）
	FORGOT_ID_CONFIRM: '/forgot-id-confirm',
	// 退会
	WITHDRAW: '/withdraw',
	// 退会(お問い合わせフォーム)
	WITHDRAW_CONTACT_FORM: '/withdraw-contact-form',
	// クレジットカード管理
	CARD_MANAGEMENT: '/card-management',
	// 登録情報
	ACCOUNT_INFO: '/account-info',
	// 家族情報
	FAMILY_INFO: '/family-info',
	// メール配信
	EMAIL_DELIVERY: '/email-delivery',
	// 属性提供同意
	ATTRIBUTE_AGREEMENT: '/attribute-agreemnt',
	// 不足属性入力
	REQUIRED_PROFILE_EDIT: '/required-profile-edit',
};

export const privatePaths = [
	RoutePath.MY_PAGE,
	RoutePath.PROFILE_EDIT,
	RoutePath.PROFILE_EDIT_MAILADDRESS,
	RoutePath.PROFILE_EDIT_MAILADDRESS_CONFIRM,
	RoutePath.PASSWORD_EDIT,
	RoutePath.MEMBER_INFO,
	RoutePath.MEMBER_REMOVE,
	RoutePath.MEMBER_REMOVE_CONTACT_FORM,
	RoutePath.MEMBER_UPDATE,
	RoutePath.MEMBER_INPUT,
	RoutePath.USER_ADD,
	RoutePath.CHANGE_REPRESENTATIVE,
	RoutePath.GET_OUT_FAMILY,
	RoutePath.LEAVE_FAMILY_ONLY,
	RoutePath.LEAVE_FAMILY_TOGETHER,
	RoutePath.WITHDRAW,
	RoutePath.WITHDRAW_CONTACT_FORM,
	RoutePath.CARD_MANAGEMENT,
	RoutePath.ACCOUNT_INFO,
	RoutePath.FAMILY_INFO,
	RoutePath.EMAIL_DELIVERY,
];

export const childNonOperablePaths = [
	RoutePath.PROFILE_EDIT,
	RoutePath.PROFILE_EDIT_MAILADDRESS,
	RoutePath.PROFILE_EDIT_MAILADDRESS_CONFIRM,
	RoutePath.PASSWORD_EDIT,
	RoutePath.MEMBER_INFO,
	RoutePath.MEMBER_REMOVE,
	RoutePath.MEMBER_REMOVE_CONTACT_FORM,
	RoutePath.MEMBER_UPDATE,
	RoutePath.MEMBER_INPUT,
	RoutePath.USER_ADD,
	RoutePath.CHANGE_REPRESENTATIVE,
	RoutePath.GET_OUT_FAMILY,
	RoutePath.LEAVE_FAMILY_ONLY,
	RoutePath.LEAVE_FAMILY_TOGETHER,
	RoutePath.WITHDRAW,
	RoutePath.WITHDRAW_CONTACT_FORM,
	RoutePath.CARD_MANAGEMENT,
	RoutePath.EMAIL_DELIVERY,
];
